(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jg-tennis-hub-hero"] && !Shopify.designMode) return;
  try {
    
const tuneTennisHubChat = () => {
  const host = document.querySelector('gty-whatsapp-chat-button');
  if (!host || !host.shadowRoot) return false;
  const wrapper = host.shadowRoot.querySelector('.gty-wacb-wrapper');
  const greeting = host.shadowRoot.querySelector('.gty-wacb-greeting-message');
  if (!wrapper || !greeting) return false;
  greeting.style.display = 'none';
  if (window.matchMedia('(max-width: 749px)').matches) {
    wrapper.style.left = 'auto';
    wrapper.style.right = '16px';
    wrapper.style.bottom = '18px';
    wrapper.style.transformOrigin = 'right bottom';
  } else {
    wrapper.style.removeProperty('right');
    wrapper.style.left = '16px';
    wrapper.style.bottom = '41px';
    wrapper.style.transformOrigin = 'left bottom';
  }
  return true;
};
let tennisHubChatAttempts = 0;
const tennisHubChatTimer = window.setInterval(() => {
  tennisHubChatAttempts += 1;
  if (tuneTennisHubChat() || tennisHubChatAttempts > 40) window.clearInterval(tennisHubChatTimer);
}, 250);
window.addEventListener('resize', tuneTennisHubChat);

  } catch(e) { console.error(e); }
})();
})();
